/**
 * DialIQ brand mark — "iQ" monogram.
 *
 * A confident lowercase "i" paired with uppercase "Q" rendered as SVG.
 * The "i" dot doubles as a phone indicator, and the Q's tail cuts
 * diagonally through its bowl like a slashed receiver.
 *
 * Used in:
 *   - Leads header button
 *   - DialIQ panel hero + footer + empty state
 *   - Settings DialIQ section
 */

export function DialIQMark({
  className = "",
  size = 28,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* lowercase i — dot + stem */}
      <circle cx="8" cy="7" r="2" fill="currentColor" />
      <rect x="6.5" y="11" width="3" height="11" rx="1.5" fill="currentColor" />

      {/* uppercase Q — ring + angled tail (like a phone receiver cord) */}
      <circle
        cx="19"
        cy="16"
        r="5.5"
        stroke="currentColor"
        strokeWidth="2.6"
      />
      <path
        d="M 20.5 19.5 L 24 23.5"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default DialIQMark;
